import { render, staticRenderFns } from "./mystie.vue?vue&type=template&id=ffc8a9a8&scoped=true&"
import script from "./mystie.vue?vue&type=script&lang=js&"
export * from "./mystie.vue?vue&type=script&lang=js&"
import style0 from "./mystie.vue?vue&type=style&index=0&id=ffc8a9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc8a9a8",
  null
  
)

export default component.exports